import { createElement } from 'react';
import '../Provider/ThemeContext.js';
import 'classnames';
import 'emotion';
import '@emotion/core';
import 'emotion-theming';
import '@emotion/styled';
import '../utils/useTheme.js';
import '../utils/useLocalStorage.js';
import { d as _objectWithoutPropertiesLoose } from '../chunk-1b90139e.js';
import '../utils/omit.js';
import '../ColorMode/utils.js';
import '../ColorMode/ColorModeContext.js';
import '../ColorMode/InitializeColorMode.js';
import '../utils/pick.js';
import '../utils/cssProps.js';
import 'lodash/kebabCase';
import 'tinycolor2';
import '../utils/isFunction.js';
import '../utils/get.js';
import '../utils/theme.js';
import '../utils/getCSSFromStyleObject.js';
import '../utils/useStyle.js';
import '../utils/usePrevious.js';
import '../utils/useOptionsState.js';
import '../utils/omitBy.js';
import '../utils/useDefaultProps.js';
import '../utils/useDebounce.js';
import 'lodash/uniq';
import '../utils/useClassName.js';
import '../utils/getMediaQueryList.js';
import '../utils/useBreakpointValue.js';
import '../utils/useBreakpoint.js';
import 'reakit/Id';
import '../utils/uniqueId.js';
import '../utils/times.js';
import '../utils/parseIcons.js';
import '../utils/colors.js';
import '../utils/palette.js';
import '../utils/mergeRefs.js';
import 'deepmerge';
import 'lodash/set';
import '../utils/applyTheme.js';
import '../utils/bindFns.js';
import '../utils/createComponent.js';
import '../utils/createElement.js';
import '../utils/createHook.js';
import '../utils/forwardRefWithUse.js';
import '../utils/fieldAdaptors.js';
import 'capsize';
import '../utils/getCapsizeStyles.js';
import '@emotion/is-prop-valid';
import '../utils/htmlProps.js';
import '../utils/OutsideClickHandler.js';
import 'reakit';
import '../Box/styles-f21497e2.js';
import '../Box/Box.js';
import '../Modal/styles-9beab3b5.js';
import { useModalState, ModalState } from '../Modal/ModalState.js';
import '../Modal/ModalBackdrop.js';
import '../Modal/Modal.js';
import '../Modal/ModalDisclosure.js';
import '../Modal/index.js';

function useDrawerState(initialState) {
  return useModalState(initialState);
}

function DrawerState(props) {
  var children = props.children,
      restProps = _objectWithoutPropertiesLoose(props, ["children"]);

  return /*#__PURE__*/createElement(ModalState, restProps, children);
}

export { DrawerState, useDrawerState };